import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

export function addQueryParams(route: ActivatedRouteSnapshot) {
  const id = route.queryParams['id'];
  const codeType = route.queryParams['codeType'];
  if (id && codeType) {
    return true;
  }

  const uuid = route.params['uuid'];
  return inject(Router).navigate(['business-card', uuid], {
    queryParams: { id: uuid, codeType: 'BUSINESS_CARD' },
  });
}
